import { Component } from "react"
import PropTypes from "prop-types"
import StencilField from "./stencil_field"
import saveStencils from "./save_stencils"

export default class MultipleStencilForm extends Component {
  static propTypes = {
    stencils: PropTypes.arrayOf(PropTypes.object).isRequired,
    ingredientsMetadata: PropTypes.object.isRequired,
    platformUnpublished: PropTypes.bool.isRequired,
  }

  state = {
    open: false,
    submitting: false,
  }

  handleSubmit = event => {
    event.preventDefault()
    this.setState({ submitting: true })

    const extractValuesFor = inputName =>
      Array.from(event.target.querySelectorAll(`[name='partner_trigger_stencils[${inputName}][]']`)).map(
        item => item.value
      )

    saveStencils(this.props.stencils[0].endpoint, {
      partner_trigger_stencils: {
        trigger_id: extractValuesFor("trigger_id"),
        value: extractValuesFor("value"),
        slug: extractValuesFor("slug"),
      },
    }).finally(() => {
      this.setState({ submitting: false })
    })
  }

  render() {
    const { ingredientsMetadata, stencils } = this.props
    const firstStencil = stencils[0]
    const iconClasses = ["action-header-icon", firstStencil.icon].join(" ")
    const openOrClosedClass = this.state.open ? "open" : "closed"

    return (
      <div className={`action-default ${openOrClosedClass}`}>
        <div
          className="action-header"
          onClick={() => this.setState({ open: !this.state.open })}
        >
          <div className={iconClasses} />
          <div className="action-header-title">
            <p>{firstStencil.name}</p>
            <p className="note">{firstStencil.example}</p>
          </div>
        </div>
        <form className="form" onSubmit={this.handleSubmit}>
          {stencils.map(stencil => (
            <div key={stencil.slug}>
              <input
                type="hidden"
                name="partner_trigger_stencils[trigger_id][]"
                value={ingredientsMetadata.trigger.id}
              />
              <input
                type="hidden"
                name="partner_trigger_stencils[slug][]"
                defaultValue={stencil.slug}
              />
              <StencilField
                fieldName="partner_trigger_stencils[value][]"
                ingredientsMetadata={ingredientsMetadata}
                stencil={stencil}
              />
            </div>
          ))}
          <div className="action">
            <button
              type="submit"
              className="button-secondary"
              disabled={
                this.state.submitting || !this.props.platformUnpublished
              }
            >
              {this.state.submitting ? "Saving…" : "Save"}
            </button>
          </div>
        </form>
      </div>
    )
  }
}
